import React from 'react';
import { Route } from 'react-router-dom'; // Switch, Redirect
import loadable from '@loadable/component';

import c from '../../../config';

const ScrollToTop = loadable(() => import('../../../components/ScrollToTop'));
const BreadCrumbNav = loadable(() => import('../../../components/BreadCrumbNav'));
const PreviewDate = loadable(() => import('../../../widgets/PreviewDate'));
const Header = loadable(() => import('../../../components/Header'));
// const Footer = loadable(() => import('../../../components/Footer'));
const Footer = loadable(() => import('../../../components/Footer'));
const NotificationGroup = loadable(() => import('../../../widgets/NotificationGroup'));
const LiveStreamingPage = loadable(() => import('../../../pages/LiveStreamingPage'));

const Main = ({ children, availableLanguages, isUnderConstruction }) => {
  const previewDateParams = new URLSearchParams(window.location.search).has('previewDate');
  const isAppParams = new URLSearchParams(window.location.search).has('isApp');

  return (
    <>
      {previewDateParams && <PreviewDate />}
      <ScrollToTop>
        <Route
          path={`${c.routePathTo}/:locale(${availableLanguages})?`}
          component={NotificationGroup}
        />
        {!isAppParams && (
          <Route
            path={`${c.routePathTo}/:locale(${availableLanguages})?/:currentPageName?`}
            render={() => (
              <>
                <Header isUnderConstruction={isUnderConstruction} />
                <LiveStreamingPage />
              </>
            )}
          />
        )}
        <div className="mainContent" role="main">
          <BreadCrumbNav>{children}</BreadCrumbNav>
        </div>
        {!isAppParams && (
          // <Route path={`${c.routePathTo}/:locale(${availableLanguages})?`} component={Footer} />
          <Route
            path={`${c.routePathTo}/:locale(${availableLanguages})?`}
            component={Footer}
          />
        )}
      </ScrollToTop>
    </>
  );
};

export default Main;
